import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css';
import { Table } from 'react-bootstrap';

export default function DashboardSalesOrder(props) {

    return (
        <>
            <div className='layout_head'>
                <h5> Sales Order List </h5>
            </div>

            <div className='section_table text-center mt-2 ' >
                <PerfectScrollbar style={{ height: '50vh' }}>
                    <Table striped bordered hover className='item_table'>
                        <thead className='head_table'>
                            <tr>
                                <th>S No.</th>
                                <th>SO Code</th>
                                <th>SO Date</th>
                                <th>Approval Status</th>
                                <th>Dispatch Status</th>
                            </tr>
                        </thead>
                        {props?.dashboard_so_list?.map((value, index) => (
                            <tbody key={index}>
                                <tr>
                                    <td>{index + 1}</td>
                                    <td>{value.vpurchase_order_code}</td>
                                    <td>{value.dpo_date1}</td>
                                    <td>{value.cstatus == 'P' ? 'Not Approved' : ' Approved'}</td>
                                    <td>{value.vdespatch_advice_no == '' || value.vdespatch_advice_no == null ? <span className=' badge text-bg-warning'>Pending</span> : value.mdespatch_qty == value?.morder_qty ? 'Full Despatch' : "Partial Despatch"}</td>
                                </tr>
                            </tbody>
                        ))}

                    </Table>
                </PerfectScrollbar>
            </div>
        </>
    )
}
